import authService from "./authService";
import SecureCookieManager from '../utils/secureCookie';

const BASE_URL = process.env.REACT_APP_API_URL;


function getToken() {
    return SecureCookieManager.getAuthToken();
}
      


export async function getInstitutions(query:string, perPage:number, pageNo:number) {
    try {
      const response =await authService.apiCall(`${BASE_URL}/tenant?query=${query}&perPage=${perPage}&pageNo=${pageNo}`, {
        method: 'GET',
      
      });

     // console.log(response);

      if (!response.ok) {
        throw new Error('Failed to get institutions');
      }

      const result = await response.json();
      //console.log('Institutions fetched successfully:', result);
      return result;
    } catch (error) {
      console.error('Error fetching institutions:', error);
      throw new Error('Error fetching institutions');
    }

}

export async function registerUsersBulk(users: any[]) {
  try {
   
    const response = await authService.apiCall(`${BASE_URL}/auth/register-bulk`, {
      method: 'POST',
    
      body: JSON.stringify({ users }),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || 'Failed to register users');
    }

    return result;
  } catch (error: any) {
    console.error('Error registering users:', error);
    throw new Error(error.message || 'An unexpected error occurred while registering users');
  }
}




export async function updateApproveStatus(id: string, approved: boolean, surveyId?: string) {
  try {
    const response =await authService.apiCall(`${BASE_URL}/tenant/${id}/approve`, {
      method: "PUT",
     
      body: JSON.stringify({ approved , surveyId}), // Send only required fields in body
    });

    if (!response.ok) {
      const errorMessage = `Failed to update approval status. Server responded with status: ${response.status}`;
      console.error(errorMessage);
      throw new Error(errorMessage);
    }

    const result = await response.json();
   // console.log("Approval status updated successfully:", result);
    return result;
  } catch (error: any) {
    console.error("Error updating approval status:", error.message || error);
    throw error; // Propagate the error to handle it in the calling function
  }
}



export async function fetchAllSurveyDataApi(options: RequestInit = {}): Promise<any[]> {
  const token = getToken();
  



  try {
    const response = await authService.apiCall(`${BASE_URL}/surveys/all`, {
      ...options,
    
    });

    const data = await response.json();

    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch surveys");
    }

    if (!Array.isArray(data.data)) {
      throw new Error("Unexpected response format: expected an array");
    }

    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Unexpected error while fetching surveys");
  }
}
